import React, { useEffect, useState/* , useEffect */ } from 'react';
import {
  Button,
  Grid,
  /*   Box, */
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Paper,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import Logo from '@jumbo/components/AppLayout/partials/LogoNoLink';
import { initFichaTecnica, getFichaTecnicaPorId } from 'services/api';
import { toast } from '@jumbo/components/custom/Toast';
import { useHistory } from 'react-router-dom';
import { TEXT_COLOR_FT } from 'config/config';

const bgImage = '/images/horizontal-header-bg-pattern.png';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    backgroundImage: `URL(${bgImage})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    color: theme.palette.common.white,
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      zIndex: 1,
      width: '100%',
      height: '100%',
      backgroundColor: alpha(theme.palette.primary.main, 0.47),
    },
    '& > *': {
      position: 'relative',
      zIndex: 3,
    },
    '& .Cmt-btn': {
      color: theme.palette.common.white,
      '&:hover, &:focus': {
        backgroundColor: alpha(theme.palette.common.white, 0.04),
        color: theme.palette.common.white,
      },
    },
    '& .Cmt-divider': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .Cmt-appIcon, & .Cmt-searchIcon': {
      color: theme.palette.common.white,
      '&:hover, &:focus': {
        backgroundColor: alpha(theme.palette.common.white, 0.04),
        color: theme.palette.common.white,
      },
    },
    '& .Cmt-lang-switch, & .Cmt-profile-pic': {
      '&:before': {
        backgroundColor: alpha(theme.palette.common.white, 0.38),
      },
    },
  },
  num: {
    display: 'block',
    width: '100%',
    fontFamily: 'Roboto',
  },
  date: {
    display: 'block',
    width: '100%',
    color: 'white',
    fontWeight: 100,
    fontSize: 'small',
    fontFamily: 'Roboto',
  },
  type: {
    display: 'block',
    width: '100%',
    color: 'white',
    fontWeight: 100,
    fontSize: 'small',
    fontFamily: 'Roboto',
  },
}));

const CondicionesDeUso = props => {
  const { openDialog = false, close, setShowForm, setShowSinFicha, user, setDatosFicha } = props;
  const classes = addStyle();
  const [checked, setChecked] = useState(false);
  const [auxId, setAuxId] = useState(null)
  const history = useHistory();

  const clearData = () => {
    setChecked(false);
  };

  const onCloseDialog = event => {
    close();
    clearData();
  };

  useEffect(() => {
    if (auxId) {
      getFichaTecnicaPorId(auxId)
        .then(res2 => {
          setDatosFicha(res2.data)
        })
        .catch(e2 => console.log(e2))
        .finally(f2 => {

        })
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auxId])

  const submit = () => {
    setShowSinFicha(false);
    setShowForm(false);
    let bodyFormData = { "nombre_prestador": user.organization.name }

    initFichaTecnica(bodyFormData)
      .then(res => {
        toast.success('ficha técnica creada con éxito')
        setAuxId(res.data.id)
        //setShowForm(true);
      })
      .catch(e => {
        console.error(e)
        toast.error('Ocurrió un error al crear la ficha técnica')
        setShowSinFicha(true);
      })
      .finally(f => {
        history.push('/ft-identificacion-prestador')
        close();
        clearData();
      })

  };

  const handleChange = () => {
    setChecked(!checked);
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog} fullScreen>
      <DialogTitle className={classes.dialogTitleRoot}>
        <Logo mr={{ xs: 2, sm: 4, lg: 6, xl: 8 }} color="white" />
      </DialogTitle>
      <DialogContent dividers style={{ backgroundColor: '#f4f4f7' }}>
        <Grid container justifyContent="center" direction="column" alignItems="center">
          <Grid item xs={8}>
            <Grid item xs={12} sm={12} md={12} style={{ padding: 15, textAlign: 'justify' }}>
              <h1>Formulario Ingreso y actualización de datos en ficha técnica para Prestadores Institucionales </h1>
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 15, paddingRight: 15 }}>
              <div style={{ height: 1, backgroundColor: '#cdcdcd' }}></div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={{ padding: 15 }}>
              <Paper>
                <Grid container item xs={12} style={{ padding: 10, textAlign: 'justify', color: TEXT_COLOR_FT }} direction="column">
                  <h2>Introducción y guía de registro</h2>
                  <br></br>
                  <p>Te invitamos a descargar y leer los siguientes documnentos:</p>
                  <br></br>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#">Información Fichas Técnicas</a>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#">Manual de registro</a>
                  <br></br>
                  <p style={{ fontWeight: 'bold' }}>Consideraciones del registro:</p>
                  <ul style={{ padding: 20 }}>
                    <li>
                      A continuación, usted comenzará con el proceso de llenado del Formulario de ingreso y
                      actualización de datos en la ficha técnica para prestadores institucionales.
                    </li>
                    <li>
                      La información solicitada está dividida en módulos de Identificación del prestador,
                      Capacidad Instalada, Equipamiento y Dotación de personal. El menú de los Módulos se
                      encuentra en la parte izquierda de la pantalla.
                    </li>
                    <li>
                      Durante el proceso de llenado, hay información que se completa de manera automática.
                      De igual forma usted debe revisar, que ésta esté actualizada y es correcta.
                    </li>
                    <li>
                      Usted debe seleccionar aquellos ítems que corresponden a su institución. Lo más probable
                      es que aparezcan ítems que usted no posea, en este caso no debe ingresarlos.
                    </li>
                    <li>
                      Cada página tendrá botón “Agregar” que le permitirá agregar capacidad instalada,
                      equipamiento o dotación de personal. Podrá ir agregando tantos ítems como sea necesario.
                    </li>
                    <li>
                      Se recomienda revisar el glosario de términos y definiciones que encontrará en el apartado de ayuda.
                    </li>
                  </ul>
                  <p style={{ fontWeight: 'bold' }}>Autorización</p>
                  <br></br>
                  <p style={{ paddingLeft: 20, paddingRight: 20, marginBottom: 10 }}>
                    El prestador de salud, en calidad de usuario, autoriza expresamente a la Superintendencia de Salud para
                    el uso de los datos proporcionados a través de este registro, con el fin de gestionar y actualizar la
                    información sobre su ficha técnica.
                  </p>
                  <p style={{ paddingLeft: 20, paddingRight: 20, marginBottom: 10 }}>
                    Los datos proporcionados serán utilizados exclusivamente para fines de gestión, almacenamiento,
                    verificación y actualización de la información correspondiente al registro de ficha técnica de
                    los prestadores de salud. Estos datos podrán ser utilizados para fines estadísticos y para la
                    mejora de servicios de salud, siempre de manera confidencial y adecuada a los fines aquí descritos.
                  </p>
                  <p style={{ paddingLeft: 20, paddingRight: 20, marginBottom: 10 }}>
                    La Superintendencia de Salud se compromete a implementar las medidas de seguridad necesarias para
                    proteger los datos proporcionados y evitar su pérdida, acceso no autorizado, alteración o divulgación.
                  </p>
                  <p style={{ paddingLeft: 20, paddingRight: 20, marginBottom: 10 }}>
                    Al aceptar los términos y condiciones, el usuario manifiesta haber leído y comprendido esta autorización,
                    otorgando su consentimiento para el uso de sus datos conforme a los fines descritos anteriormente.
                  </p>
                  <br></br>
                  <Grid container justifyContent="center" direction="column" alignItems="center">
                    <FormControlLabel
                      label="Acepto"
                      control={
                        <Checkbox checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
                      }
                    />
                    <br></br>
                    <Grid container spacing={4} justifyContent="center">
                      <Grid item xs={4}>
                        <Button fullWidth variant="contained" color="primary" onClick={onCloseDialog}
                          style={{ backgroundColor: 'green', color: 'white', }}
                        >
                          &nbsp;Cerrar&nbsp;
                        </Button>
                      </Grid>
                      <Grid item xs={4}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={submit}
                          style={{ marginRight: 10 }}
                          fullWidth
                          disabled={!checked}>
                          &nbsp; Guardar y Continuar &nbsp;
                        </Button>
                      </Grid>
                    </Grid>
                    <br></br>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CondicionesDeUso;
